/**
 * INCIDENT SERVICE — Mobile-ready business logic layer
 */
import hosys from "@/api/api";
import moment from "moment";

export const CATEGORY_LABELS = {
  food_safety:           "Seguretat alimentària",
  equipment_failure:     "Avaria d'equip",
  temperature_deviation: "Desviació temperatura",
  cleaning_issue:        "Problema de neteja",
  supplier_issue:        "Problema proveïdor",
  staff_issue:           "Incidència personal",
  other:                 "Altres",
};

export const SEVERITY_CONFIG = {
  low:      { label: "Baixa",   color: "blue" },
  medium:   { label: "Mitjana", color: "amber" },
  high:     { label: "Alta",    color: "orange" },
  critical: { label: "Crítica", color: "red" },
};

export async function createIncident(venueId, user, data) {
  const incident = await hosys.entities.Incident.create({
    venue_id: venueId,
    title: data.title,
    category: data.category,
    description: data.description || "",
    severity: data.severity,
    status: "open",
    corrective_action: data.corrective_action || "",
    responsible_email: user.email,
    responsible_name: user.full_name,
    photo_urls: data.photo_urls || [],
    date: data.date || moment().format("YYYY-MM-DD"),
  });

  let alert = null;
  if (data.severity === "high" || data.severity === "critical") {
    alert = await hosys.entities.Alert.create({
      venue_id: venueId,
      type: "incident",
      title: `Incidència ${data.severity === "critical" ? "crítica" : "alta"}: ${data.title}`,
      message: data.description || "",
      severity: data.severity === "critical" ? "critical" : "danger",
      status: "active",
      reference_type: "Incident",
      reference_id: incident.id,
    });
  }

  return { incident, alert };
}

export async function updateIncident(incidentId, updates) {
  return hosys.entities.Incident.update(incidentId, updates);
}

export async function closeIncident(incidentId, correctiveAction) {
  return hosys.entities.Incident.update(incidentId, { status: "closed", corrective_action: correctiveAction });
}

export async function getIncidents(venueId, filters = {}) {
  return hosys.entities.Incident.filter({ venue_id: venueId, ...filters }, "-created_date");
}

export async function getIncidentSummary(venueId) {
  const incidents = await getIncidents(venueId);
  return {
    total: incidents.length,
    open: incidents.filter(i => i.status === "open").length,
    inProgress: incidents.filter(i => i.status === "in_progress").length,
    critical: incidents.filter(i => i.severity === "critical" && i.status !== "closed").length,
    incidents,
  };
}